<script>
  import Header from "../../../../lib/components/Header.svelte";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
  import { isValidRegex } from "../../../../lib/util/regex";
  import { PROJECT_STAGES } from "@utils/stagesAndSteps.js";
  import {
    Modal,
    Select,
    SelectItem,
    DataTable,
    Pagination,
    DataTableSkeleton,
  } from "carbon-components-svelte";
  import { Accordion, TextInput, SectionWrapper } from "paxray-components-svelte";
  import RulesList from "./RuleList.svelte";
  import ButtonIconOnly from "../../../../lib/components/buttonIconOnly.svelte";
  import ButtonNew from "../../../../lib/components/ButtonNew.svelte";
  import Button from "@components/Button.svelte";
  import { fly } from "svelte/transition";
  import ProjectStepActions from "../components/ProjectStepActions.svelte";

  const urlParams = new URLSearchParams(window.location.search);
  const idproject = urlParams.get("idproject");
  const step = PROJECT_STAGES.DATA_COLLECTION.steps.CONF_DATA_CAPT;
  const stage = PROJECT_STAGES.DATA_COLLECTION.id;

  let openModal = false;
  let listOfRules = [];
  let applications = [];
  let applicationnames = [];
  let selectedRule = "";
  let selectedOptions = [];
  let loading = false;
  let selectedRowAppname;
  let selectedRowWindowtitle;
  let rowsRules = [];
  let additionalLines = [];
  let pageApp = 1;
  let pageSizeApp = 5;
  let pageRules = 1;
  let pageSizeRules = 5;
  let filteredRowIdsApp = [];
  let searchUIElement = "";
  let replaceUIElement = "";
  let previewUIElement = "";
  let idprocessidentifiersettings = "";
  let uniqueApplicationNames = [];
  let uniqueWindowTitles = [];
  let rowsApp = [];
  let processIdentifiers = [];
  let selectedRowIds = [];
  let loadingRules = false;

  let options = [
    { value: "elementid", text: "ID" },
    { value: "elementname", text: "Name" },
    { value: "elementtype", text: "Type" },
    { value: "accesskey", text: "Access Key" },
    { value: "acceleratorkey", text: "Accelerator Key" },
    { value: "windowtitle", text: "WindowTitle" },
  ];

  let appfilter = {
    appname: "",
    windowtitle: "",
    count: "",
    elementid: "",
    elementname: "",
    elementtype: "",
    accesskey: "",
    acceleratorkey: "",
  };

  let headerApp = [
    { key: "appname", value: "App Name", width: "10%" },
    { key: "windowtitle", value: "Window Title", width: "20%" },
    { key: "elementid", value: "Element ID", width: "10%" },
    { key: "elementname", value: "Element Name", width: "10%" },
    { key: "elementtype", value: "Element Type", width: "10%" },
    { key: "accesskey", value: "Access Key", width: "10%" },
    { key: "acceleratorkey", value: "Accelerator Key", width: "10%" },
    { key: "elementvalue", value: "Element Value", width: "10%" },
  ];

  let headerRules = [
    { key: "application", value: "Application" },
    { key: "windowtitle", value: "Window Title" },
    { key: "elementproperty", value: "Element Property" },
    { key: "propertyname", value: "Property Name" },
    { key: "search", value: "Search" },
    { key: "replace", value: "Replace" },
    { key: "previewvalue", value: "Preview Value" },
    { key: "actions", value: "" },
  ];

  $: applicationnames = rowsApp.map((item) => {
    return { key: item.appname };
  });

  $: uniqueApplicationNames = getUniqueApplicationNames(rowsApp);

  $: previewUIElement = findUIElement(searchUIElement, replaceUIElement);

  $: listOfRules = processIdentifiers;

  $: getProcessIdentifierSettings(selectedRule);
  $: if (appfilter) filterAppList();

  getProcessIdentifiers();
  getApplicationElementSettings();

  function getUniqueApplicationNames(rowsApp) {
    uniqueApplicationNames = [
      ...new Set(
        rowsApp.map((item) => {
          return item.appname;
        }),
      ),
    ];
    return uniqueApplicationNames;
  }

  function getApplicationElementSettings() {
    loading = true;
    fetchWithSession(
      `/api/damprojects/getApplicationElementSettings?idproject=${idproject}`,
    )
      .then((response) => response.json())
      .then((data) => {
        rowsApp = data;
        applications = rowsApp;
        uniqueApplicationNames = getUniqueApplicationNames(rowsApp);
        filterAppList();
        loading = false;
      });
  }

  function getProcessIdentifiers() {
    fetchWithSession(`/api/damprojects/processidentifiers/${idproject}`)
      .then((response) => response.json())
      .then((data) => {
        processIdentifiers = data;
      });
  }

  async function saveRule() {
    if (!selectedRule) return;
    await saveSettings();
    if (idprocessidentifiersettings) {
      await saveSelectors(idprocessidentifiersettings);
    }
    await getProcessIdentifierSettings(selectedRule);
  }

  function createRule(ruleName) {
    fetchWithSession(`/api/damprojects/processidentifiers`, {
      method: "POST",
      body: JSON.stringify({
        idprojects: idproject,
        name: ruleName,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        ruleName = "";
        getProcessIdentifiers();
      });
  }

  function updateRule(ruleName) {
    fetchWithSession(
      `/api/damprojects/processidentifiers/update/${selectedRule}`,
      {
        method: "POST",
        body: JSON.stringify({
          name: ruleName,
        }),
      },
    )
      .then((res) => res.json())
      .then((data) => {
        ruleName = "";
        getProcessIdentifiers();
      });
  }

  function removeRule() {
    fetchWithSession(
      `/api/damprojects/processidentifiers/delete/${selectedRule}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        getProcessIdentifiers();
      });
  }

  async function getProcessIdentifierSettings(selectedRule) {
    if (!selectedRule) {
      rowsRules = [];
      return;
    }
    loadingRules = true;
    const response = await fetchWithSession(
      `/api/damprojects/processidentifiersettings/${selectedRule}`,
    );
    const data = await response.json();
    rowsRules = data;
    const extendedRows = [];
    for (const row of rowsRules) {
      const selectors = await getProcessIdentifiersSelector(row.id);
      if (selectors && selectors.length > 0) {
        selectors.forEach((selector) => {
          const elementproperty = mapElementProperty(selector.elementproperty);
          extendedRows.push({
            id: selector.id,
            application: row.appname,
            windowtitle: row.windowtitleorurl,
            elementproperty: elementproperty,
            propertyname: selector.propertyname,
            search: row.search,
            replace: row.replace,
            previewvalue: findUIElement(
              row.search,
              row.replace,
              elementproperty === "WindowTitle",
              true,
            ),
            actions: "",
            idprocessidentifiers: row.idprocessidentifiers,
            idprocessidentifiersettings: row.id,
          });
        });
      } else {
        extendedRows.push({
          id: row.id,
          application: row.appname,
          windowtitle: row.windowtitleorurl,
          elementproperty: "",
          propertyname: "",
          search: row.search,
          replace: row.replace,
          previewvalue: findUIElement(row.search, row.replace, false, true),
          actions: "",
          idprocessidentifiers: row.idprocessidentifiers,
          idprocessidentifiersettings: row.id,
        });
      }
    }
    rowsRules = extendedRows;
    loadingRules = false;
    resetValues();
  }

  async function getProcessIdentifiersSelector(idprocessidentifiersettings) {
    const response = await fetchWithSession(
      `/api/damprojects/processidentifierselectors/${idprocessidentifiersettings}`,
    );
    const data = await response.json();
    return data;
  }

  async function saveSettings() {
    let appnamefromSelectedRows = "";
    let windowtitlefromSelectedRows = "";
    if (selectedRowIds.length > 0) {
      appnamefromSelectedRows = applications.filter(
        (item) => item.id === selectedRowIds[0],
      )[0].appname;
      windowtitlefromSelectedRows = applications.filter(
        (item) => item.id === selectedRowIds[0],
      )[0].windowtitle;
    }
    const data = {
      idprocessidentifiers: selectedRule,
      appname: appfilter.appname,
      search: searchUIElement,
      replace: replaceUIElement,
      windowtitleorurl: appfilter.windowtitle,
      isbrowser: false,
    };
    const response = await fetchWithSession(
      "/api/damprojects/processidentifiersettings",
      {
        method: "POST",
        body: JSON.stringify(data),
      },
    );
    const result = await response.json();
    idprocessidentifiersettings = result.id;
    if (idprocessidentifiersettings) {
      await saveSelectors(idprocessidentifiersettings);
    }
  }

  async function saveSelectors(id) {
    const propertiesToCheck = [
      "elementid",
      "elementname",
      "elementtype",
      "accesskey",
      "acceleratorkey",
    ];
    const promises = propertiesToCheck.map(async (property) => {
      if (appfilter[property]) {
        const data = {
          idprocessidentifiersettings: id,
          elementproperty: property,
          propertyname: appfilter[property],
        };
        const response = await fetchWithSession(
          "/api/damprojects/processidentifierselectors",
          {
            method: "POST",
            body: JSON.stringify(data),
          },
        );
        const result = await response.json();
      }
    });
    if (selectedOptions.includes("windowtitle")) {
      const data = {
        idprocessidentifiersettings: id,
        elementproperty: "windowtitle",
        propertyname: "",
      };
      const response = await fetchWithSession(
        "/api/damprojects/processidentifierselectors",
        {
          method: "POST",
          body: JSON.stringify(data),
        },
      );
      const result = await response.json();
      selectedOptions = selectedOptions.filter(
        (option) => option !== "windowtitle",
      );
    }
    await Promise.all(promises);
    resetValues();
  }

  function removeSelector(id) {
    fetchWithSession(
      `/api/damprojects/processidentifierselectors/delete/${id}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        getProcessIdentifierSettings(selectedRule);
      });
  }

  function removeSettings(id) {
    fetchWithSession(
      `/api/damprojects/processidentifiersettings/delete/${id}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        getProcessIdentifierSettings(selectedRule);
      });
  }

  function deleteRowRule(row) {
    const otherRows = rowsRules.find(
      (r) =>
        r.idprocessidentifiersettings === row.idprocessidentifiersettings &&
        r.id !== row.id,
    );
    if (!row.elementproperty) removeSettings(row.id);
    else {
      if (!otherRows) {
        removeSelector(row.id);
        removeSettings(row.idprocessidentifiersettings);
      } else removeSelector(row.id);
    }
  }

  function findUIElement(
    searchUIElement,
    replaceUIElement,
    findInWindowtitle = false,
    duplicate = false,
  ) {
    if (!isValidRegex(searchUIElement)) return;
    if (!replaceUIElement) return;
    const regex = new RegExp(searchUIElement, "gi"); // Create a case-insensitive regex
    const processRow = (row) => {
      if (
        (selectedOptions.includes("windowtitle") || findInWindowtitle) &&
        regex.test(row.windowtitle)
      ) {
        return row.windowtitle.replace(regex, replaceUIElement);
      }
      if (regex.test(row.elementid)) {
        return row.elementid.replace(regex, replaceUIElement);
      }
      return null;
    };

    const rowsToProcess =
      selectedRowIds.length > 0
        ? rowsApp.filter((row) => selectedRowIds.includes(row.id))
        : rowsApp;

    for (const row of rowsToProcess) {
      const result = processRow(row);
      if (result) {
        if (!duplicate) previewUIElement = result;
        return result;
      }
    }
    console.warn("No matching element found.");
    return null;
  }

  function addLine() {
    additionalLines = [...additionalLines, {}];
    selectedOptions = [...selectedOptions, ""];
  }

  function removeLine(index) {
    appfilter[selectedOptions[index]] = "";
    additionalLines = additionalLines.slice(0, -1);
    selectedOptions.splice(index, 1);
  }

  function duplicateLine(row) {
    const elementproperty = mapTextToValue(row.elementproperty);
    const elementpropertyText = mapElementProperty(elementproperty);
    searchUIElement = row.search;
    replaceUIElement = row.replace;
    previewUIElement = row.previewvalue;
    previewUIElement = findUIElement(
      searchUIElement,
      replaceUIElement,
      elementpropertyText === "WindowTitle",
      true,
    );
    appfilter.appname = row.application;
    appfilter.windowtitle = row.windowtitle;
    if (elementproperty !== "windowtitle")
      appfilter[elementproperty] = row.propertyname;
    selectedOptions[0] = elementproperty;
    options[elementproperty] = row.propertyname;
    selectedOptions = [...selectedOptions];
  }

  function filterAppList() {
    applications = rowsApp.filter((item) => {
      let matches = true;
      if (appfilter.appname != "") {
        matches =
          matches &&
          item.appname.toLowerCase().includes(appfilter.appname.toLowerCase());
      }
      if (appfilter.windowtitle != "") {
        try {
          matches =
            matches && new RegExp(appfilter.windowtitle).test(item.windowtitle);
        } catch (e) {
          matches = false;
        }
      }
      if (appfilter.elementid != "") {
        matches =
          matches &&
          item.elementid
            .toLowerCase()
            .includes(appfilter.elementid.toLowerCase());
      }
      if (appfilter.elementname != "") {
        matches =
          matches &&
          item.elementname
            .toLowerCase()
            .includes(appfilter.elementname.toLowerCase());
      }
      if (appfilter.elementtype != "") {
        matches =
          matches &&
          item.elementtype
            .toLowerCase()
            .includes(appfilter.elementtype.toLowerCase());
      }
      if (appfilter.accesskey != "") {
        matches =
          matches &&
          item.accesskey
            .toLowerCase()
            .includes(appfilter.accesskey.toLowerCase());
      }
      if (appfilter.acceleratorkey != "") {
        matches =
          matches &&
          item.acceleratorkey
            .toLowerCase()
            .includes(appfilter.acceleratorkey.toLowerCase());
      }
      return matches;
    });
    filteredRowIdsApp = applications.map((item) => item.id);
    if (filteredRowIdsApp.length > 0) {
      selectedRowWindowtitle = applications[0].windowtitle;
      selectedRowAppname = applications[0].appname;
    }
  }

  function mapElementProperty(propertyKey) {
    const option = options.find((opt) => opt.value === propertyKey);
    return option ? option.text : propertyKey;
  }

  function mapTextToValue(text) {
    const option = options.find((opt) => opt.text === text);
    return option ? option.value : text;
  }

  function resetValues() {
    searchUIElement = "";
    replaceUIElement = "";
    previewUIElement = "";
    appfilter = {
      appname: "",
      windowtitle: "",
      count: "",
      elementid: "",
      elementname: "",
      elementtype: "",
      accesskey: "",
      acceleratorkey: "",
    };
    additionalLines = [];
    selectedRowIds = [];
    selectedOptions = [];
  }

  $$restProps;
</script>

<Header section="Object Support" breadcrumb="Assistant">
  <ProjectStepActions
    {idproject}
    {step}
    {stage}
  />
</Header>

<SectionWrapper fitScreen>
  <div class="main" slot="main">
    <div class="" style="margin-top: 0.5rem;">
      <div class="section-wrapper">
        <div class="list-wrapper">
          <div class="filter-wrapper" style="align-items: end;">
            <TextInput
              labelText="Application"
              size="sm"
              bind:value={appfilter.appname}
              placeholder="All Applications"
              list="Application"
              on:change={filterAppList}
            />
            <datalist id="Application">
              {#each uniqueApplicationNames.sort() as application}
                <option value={application} />
              {/each}
            </datalist>
            <TextInput
              labelText="Window Title"
              size="sm"
              bind:value={appfilter.windowtitle}
              placeholder="All Window Titles"
              list="WindowTitle"
              on:change={filterAppList}
            />
            <datalist id="WindowTitle">
              {#each uniqueWindowTitles as application}
                <option value={application.key} />
              {/each}
            </datalist>
          </div>
        </div>
        <div class="list-wrapper">
          <div class="filter-wrapper">
            <div class="additional-line">
              <div class="filter-wrapper">
                <Select
                  labelText="Element Property"
                  size="sm"
                  bind:selected={selectedOptions[0]}
                  on:change={(e) => (selectedOptions[0] = e.target.value)}
                >
                  <SelectItem value=""></SelectItem>
                  {#each options as option}
                    <SelectItem value={option.value} text={option.text}
                    ></SelectItem>
                  {/each}
                </Select>
                <TextInput
                  labelText="Search"
                  size="sm"
                  placeholder="Search for UI Element"
                  bind:value={appfilter[selectedOptions[0]]}
                  disabled={selectedOptions[0] === "windowtitle"}
                />
                <div class="button-wrapper">
                  <ButtonIconOnly icon="plus" on:click={addLine} small />
                </div>
              </div>
              {#each additionalLines as _, index}
                <div class="filter-wrapper">
                  <Select
                    labelText="Element Property"
                    size="sm"
                    on:change={(e) =>
                      (selectedOptions[index + 1] = e.target.value)}
                  >
                    <SelectItem value=""></SelectItem>
                    {#each options as option}
                      <SelectItem value={option.value} text={option.text}
                      ></SelectItem>
                    {/each}
                  </Select>
                  <TextInput
                    labelText="Search"
                    size="sm"
                    placeholder="Search for UI Element"
                    bind:value={appfilter[selectedOptions[index + 1]]}
                    disabled={selectedOptions[index + 1] === "windowtitle"}
                  />
                  <div class="button-wrapper">
                    <ButtonIconOnly
                      icon="minus"
                      on:click={() => removeLine(index + 1)}
                      small
                    />
                  </div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
      <div>
        {#if loading}
          <DataTableSkeleton
            headers={headerApp}
            showHeader={false}
            showToolbar={false}
            size="short"
          />
        {:else}
          <DataTable
            class="custom-app-table"
            size="short"
            rows={applications}
            headers={headerApp}
            selectable
            page={pageApp}
            pageSize={pageSizeApp}
            sortable
            bind:selectedRowIds
          >
            <svelte:fragment slot="cell" let:cell let:row>
              <div
                style="overflow-x:hidden; white-space:nowrap; text-overflow: ellipsis;"
                title={cell.value}
              >
                {cell.value}
              </div>
            </svelte:fragment>
          </DataTable>
        {/if}
        <Pagination
          totalItems={filteredRowIdsApp.length}
          pageSizes={[5, 10, 15, 20]}
          bind:page={pageApp}
          bind:pageSize={pageSizeApp}
        />
      </div>

      <div class="search-replace">
        <TextInput
          labelText="Search"
          size="sm"
          bind:value={searchUIElement}
          placeholder="Search for UI Element"
          on:change={findUIElement}
          invalidText="Invalid regex"
          invalid={!isValidRegex(searchUIElement)}
        />
        <TextInput
          labelText="Replace"
          size="sm"
          bind:value={replaceUIElement}
          placeholder="Replace with UI Element"
        />
        <TextInput
          readonly
          labelText="Preview Value"
          size="sm"
          bind:value={previewUIElement}
        />
        <div class="button-wrapper">
          <ButtonNew
            on:click={saveRule}
            secondary={true}
            setting={true}
            text="Save"
            disabled={selectedRule === ""}
          ></ButtonNew>
        </div>
      </div>
      <div>
        {#if loadingRules}
          <DataTableSkeleton
            headers={headerRules}
            showHeader={false}
            showToolbar={false}
            size="short"
          />
        {:else}
          <DataTable
            size="short"
            rows={rowsRules}
            headers={headerRules}
            selectable
            page={pageRules}
            pageSize={pageSizeRules}
          >
            <svelte:fragment slot="cell" let:cell let:row>
              {#if cell.key === "actions"}
                <div class="action-wrapper">
                  <ButtonIconOnly
                    icon="plus"
                    on:click={() => {
                      resetValues();
                      duplicateLine(row);
                    }}
                    small
                  />
                  <ButtonIconOnly
                    icon="trash"
                    on:click={deleteRowRule(row)}
                    small
                  />
                </div>
              {:else}
                {cell.value}
              {/if}
            </svelte:fragment>
          </DataTable>

          <Pagination
            totalItems={rowsRules.length}
            pageSizes={[5, 10, 15, 20]}
            bind:page={pageRules}
            bind:pageSize={pageSizeRules}
          />
        {/if}
      </div>
    </div>
  </div>
  <div slot="menu" class="menu">
    <Accordion heading="Rules" open={true}>
      <RulesList
        rules={listOfRules}
        bind:selectedRule
        {createRule}
        {updateRule}
        {removeRule}
      />
    </Accordion>
  </div>
</SectionWrapper>

<Modal
  preventCloseOnClickOutside
  open={openModal}
  modalHeading="Rule Name"
  passiveModal
  size="lg"
></Modal>



<style>
  .main {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    box-sizing: border-box;
  }

  .section-wrapper {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    flex: 1;
  }

  .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
  }

  .filter-wrapper {
    display: flex;
    gap: 1rem;
    flex-direction: row;
    flex: 1;
  }

  .additional-line {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    flex: 1;
  }

  .button-wrapper {
    align-self: flex-end;
  }

  .search-replace {
    margin: 1.5rem 0 1rem 0;
    display: flex;
    gap: 1rem;
    flex-direction: row;
    flex: 1;
  }

  .action-wrapper {
    display: flex;
    gap: 0.5rem;
    flex-direction: row;
  }

  :global(.custom-app-table .bx--data-table thead tr th:first-child) {
    width: 3%;
  }
</style>
